import { useQuery } from '@tanstack/react-query';
import { enumsAPI, languagesAPI, preferencesAPI } from '../services/api';
import { queryKeys } from '../queryKeys';

export function useTypes() {
  return useQuery({
    queryKey: queryKeys.enums.types(),
    queryFn: () => enumsAPI.getTypes(),
    staleTime: Infinity,
  });
}

export function useLanguages() {
  return useQuery({
    queryKey: queryKeys.languages.all,
    queryFn: () => languagesAPI.getLanguages(),
  });
}

export function usePreferences() {
  return useQuery({
    queryKey: queryKeys.preferences.all,
    queryFn: () => preferencesAPI.getPreferences(),
  });
}
